import { render, staticRenderFns } from "./BtnPanels.vue?vue&type=template&id=75a10260"
import script from "./BtnPanels.vue?vue&type=script&lang=js"
export * from "./BtnPanels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports